/**
 * Unified management of permission constants to avoid hardcoded strings throughout the project, making maintenance easier.
 */

/**
 * Button permission prefix
 */
export const permissionPrefix = "permission:button";

/**
 * Common button permissions:
 * - get: view/read
 * - update: edit/modify
 * - delete: remove
 * - add: create
 */
export const accessControlCodes = {
	get: `${permissionPrefix}:get`,
	update: `${permissionPrefix}:update`,
	delete: `${permissionPrefix}:delete`,
	add: `${permissionPrefix}:add`,
};

export const AccessControlRoles = {
	admin: "admin",
	common: "common",
	// user: "user",
};
